import { supabase } from './client';

export async function saveFinancialValuesPreference(showValues: boolean): Promise<void> {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user?.id) {
      console.warn('Erro ao obter usuário:', userError);
      return;
    }

    console.log('💾 Salvando preferência de valores financeiros:', showValues, 'para usuário:', user.id);

    const { error } = await supabase
      .from('user_preferences')
      .upsert(
        {
          user_id: user.id,
          show_financial_values: showValues,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.warn('Erro ao salvar preferência de valores financeiros:', error);
    } else {
      console.log('✅ Preferência salva com sucesso!');
    }
  } catch (error) {
    console.warn('Falha ao salvar preferência:', error);
  }
}

export async function getFinancialValuesPreference(): Promise<boolean> {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user?.id) {
      console.warn('Erro ao obter usuário para carregar preferência:', userError);
      return true;
    }

    console.log('📖 Carregando preferência de valores financeiros para usuário:', user.id);

    const { data, error } = await supabase
      .from('user_preferences')
      .select('show_financial_values')
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) {
      console.warn('Erro ao buscar preferência de valores financeiros:', error);
      return true;
    }

    const preference = data?.show_financial_values ?? true;
    console.log('✅ Preferência carregada:', preference);
    return preference;
  } catch (error) {
    console.warn('Falha ao buscar preferência:', error);
    return true;
  }
}

export async function saveUpdateCardExpandedPreference(isExpanded: boolean): Promise<void> {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user?.id) {
      console.warn('Erro ao obter usuário:', userError);
      return;
    }

    console.log('💾 Salvando preferência de card expandido:', isExpanded, 'para usuário:', user.id);

    const { error } = await supabase
      .from('user_preferences')
      .upsert(
        {
          user_id: user.id,
          update_card_expanded: isExpanded,
          updated_at: new Date().toISOString(),
        },
        { onConflict: 'user_id' }
      );

    if (error) {
      console.warn('Erro ao salvar preferência de card expandido:', error);
    } else {
      console.log('✅ Preferência de card expandido salva com sucesso!');
    }
  } catch (error) {
    console.warn('Falha ao salvar preferência:', error);
  }
}

export async function getUpdateCardExpandedPreference(): Promise<boolean> {
  try {
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user?.id) {
      console.warn('Erro ao obter usuário para carregar preferência:', userError);
      return true;
    }

    console.log('📖 Carregando preferência de card expandido para usuário:', user.id);

    const { data, error } = await supabase
      .from('user_preferences')
      .select('update_card_expanded')
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) {
      console.warn('Erro ao buscar preferência de card expandido:', error);
      return true;
    }

    const preference = data?.update_card_expanded ?? true;
    console.log('✅ Preferência de card expandido carregada:', preference);
    return preference;
  } catch (error) {
    console.warn('Falha ao buscar preferência:', error);
    return true;
  }
}
